import React, { useState, ChangeEvent } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { useInsightContentData } from 'hooks/useInsightModalState'
// @ts-ignore
import { Menu, Select } from '@netbasequid/core'
import { DashboardWidgetData } from 'features/widget/types'
import { SentenceRetrievalResult } from 'schemas/SentenceRetrievalResultSchema'
import { useDisplayTheme } from 'hooks/useUiState'
import { Theme } from 'features/ui/types'
import UnexpectedErrorBoundary from 'components/UnexpectedErrorBoundary'
import { AutomationId } from 'utils/automationUtil'
import messageUtil from 'utils/messageUtil'
import { InsightContentSettingType } from '../types'
import InsightContentType from '../enum/InsightContentType'
import SoundbitesSortType from '../enum/SoundbitesSortType'
import { StyledSortingContainer } from '../Soundbite/index.css'
import RunSearchEffect from './RunSearchEffect'
import DocumentSoundbite from './DocumentSoundbite'
import LoadingSoundbiteGroup from './LoadingSoundbiteGroup'

const SELECT_WIDTH = '210px'

const StyledNoDataContent = styled.div`
  padding: 8px 0;
`

const Comment = ({ detailSetting }: { detailSetting: InsightContentSettingType }) => {
  const insightContent = useInsightContentData(InsightContentType.COMMENT)
  const [value, setValue] = useState(SoundbitesSortType.TIME)
  const theme = useDisplayTheme() as Theme
  const { t } = useTranslation()

  return (
    <UnexpectedErrorBoundary>
      <RunSearchEffect detailSetting={detailSetting} sortBy={value}>
        {insightContent?.status === 'loading' ? (
          <LoadingSoundbiteGroup />
        ) : (
          <>
            {insightContent?.data?.[0]?.results?.[0]?.data?.totalCount === '0' ? (
              <StyledNoDataContent
                data-testid={AutomationId.insightModal.insightContent.topAuthor.noData}>
                {t('insightModalCommentNoData')}
              </StyledNoDataContent>
            ) : (
              <>
                <StyledSortingContainer>
                  {t('sortBy')}
                  <Select
                    disabled={insightContent?.status === 'loading'}
                    name="insight-modal-select"
                    width={SELECT_WIDTH}
                    mode={theme}
                    value={value}
                    onChange={(event: ChangeEvent<HTMLInputElement>) => {
                      setValue(event.target.value)
                    }}
                    menuProps={{
                      disablePortal: true
                    }}>
                    <Menu.MenuItem value={SoundbitesSortType.TIME}>
                      {messageUtil.soundbiteSortOptions(SoundbitesSortType.TIME)}
                    </Menu.MenuItem>
                    <Menu.MenuItem value={SoundbitesSortType.AUTHOR_FOLLOWER}>
                      {messageUtil.soundbiteSortOptions(SoundbitesSortType.FOLLOWERS_VISITORS)}
                    </Menu.MenuItem>
                  </Select>
                </StyledSortingContainer>
                {insightContent?.data?.map(
                  (data: DashboardWidgetData<SentenceRetrievalResult>, index: number) => (
                    <DocumentSoundbite
                      data={data.results![0]!.data}
                      // eslint-disable-next-line react/no-array-index-key
                      key={`${data.lastUpdateTime}-${index}`}
                      serialNumber={index}
                    />
                  )
                )}
              </>
            )}
          </>
        )}
      </RunSearchEffect>
    </UnexpectedErrorBoundary>
  )
}
export default Comment
